import { ReactNode } from "react"
import { Tooltip, TooltipProps } from "@chakra-ui/react"

type TooltipLabelProps = {
  children: ReactNode
  value: ReactNode
  variant?: "dark" | "light"
  placement?: "left" | "top" | "right" | "bottom"
  width?: string
  hasArrow?: boolean
  props?: Omit<TooltipProps, "children">
}

export default function TooltipLabel({
  children,
  value,
  variant = "dark",
  placement = "bottom",
  width = "fit-content",
  hasArrow = true,
  props,
}: TooltipLabelProps) {
  if (!value) return children

  return (
    <Tooltip
      hasArrow={hasArrow}
      placement={placement}
      closeOnClick={false}
      fontWeight={500}
      fontFamily="riforma.medium"
      bg={variant === "dark" ? "primary.black.100" : "primary.white.100"}
      color={variant === "dark" ? "primary.white.100" : "primary.black.100"}
      textAlign="center"
      label={value}
      width={width}
      minWidth={width}
      {...props}
    >
      {children}
    </Tooltip>
  )
}
